<template>
  <span>
    <a :class="linkClass" @click="click" :href="href" :data-btn-type="type"
      ><slot
    /></a>
    <inline-modal
      container-class="hyperlink-gate-modal"
      :requested="active"
      @modal-closed="close"
    >
      <loading-spinner v-if="status === 'loading'"></loading-spinner>
      <div
        v-if="status === 'pending'"
        class="site_alert"
        :class="{ loading: this.status === 'loading' }"
      >
        <div class="content gate sprout-form">
          <slot name="information"></slot>
          <div ref="quoteForm" v-html="html">
            <!-- HTML is loaded via XHR. -->
          </div>
        </div>
        <ul v-if="errors" class="errors">
          <li v-for="(messages, key) in errors" v-bind:key="key">
            <span v-for="(message, index) in messages" v-bind:key="index">
              {{ message }}
            </span>
          </li>
        </ul>
        <div class="actions">
          <button @click.prevent="submit" type="submit" class="primary">
            {{ confirmText }}
          </button>
          <button
            v-if="skippable"
            type="button"
            class="secondary"
            @click="skip()"
          >
            Skip
          </button>
          <button
            v-if="!skippable"
            type="button"
            class="secondary"
            @click="close()"
          >
            {{ cancelText }}
          </button>
        </div>
      </div>
      <div
        v-if="status === 'success' || status === 'skipped'"
        class="site_alert"
      >
        <div class="content">
          <slot name="success"></slot>
          <p class="download">
            Your download should start automatically, if not
            <a :href="destinationUrl" target="_blank">click here</a>.
          </p>
        </div>
      </div>
    </inline-modal>
  </span>
</template>
<script>
import axios from "axios";
import InlineModal from "./InlineModal";
import LoadingSpinner from "../atoms/loading_spinner.js";

export default {
  components: {
    InlineModal,
    LoadingSpinner,
  },
  computed: {
    csrfTokenName() {
      return window.Craft.csrfTokenName;
    },
    csrfTokenValue() {
      return window.Craft.csrfTokenValue;
    },
    successDescriptionComputed() {
      return this.status === "skipped"
        ? this.successDescription
        : `<div class="merged">${this.successDescription} <p>A LightArt team member will be in touch.</p></div>`;
    },
  },
  props: {
    linkClass: {
      type: String,
      required: false,
      default: "hyperlink-gate-anchor",
    },
    href: {
      type: String,
      required: true,
    },
    resourceName: {
      type: String,
      required: false,
    },
    resourceImage: {
      type: String,
      required: false,
    },
    cancelText: {
      type: String,
      required: false,
      default: "Cancel",
    },
    confirmText: {
      type: String,
      required: false,
      default: "Submit",
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    form: {
      type: String,
      required: false,
    },
    skippable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      status: "pending",
      class: "class list hero",
      active: false,
      errors: [],
      emailInputModel: localStorage.getItem("authGateEmail")
        ? localStorage.getItem("authGateEmail")
        : null,
      destinationUrl: null,
      html: "",
    };
  },
  mounted() {},
  methods: {
    get(e) {
      this.status = "loading";

      const config = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      axios
        .get(`/configurator-module/api/template/form/${this.form}`, config)
        .then((response) => {
          this.html = response.data;

          if (this.emailInputModel !== null) {
            setTimeout(() => {
              this.submit(e, true);
            }, 10);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.status = "pending";
        });
    },
    click(e) {
      e.preventDefault();
      this.destinationUrl = this.href;

      this.emailInputModel = localStorage.getItem("authGateEmail")
        ? localStorage.getItem("authGateEmail")
        : null;

      this.open(e);
    },
    close() {
      this.active = false;
    },
    open(e) {
      this.active = true;
      this.get(e);
    },
    skip() {
      this.continueNavigation();
      this.close();
    },
    submit() {
      this.status = "loading";

      let formElement = this.$refs.quoteForm.firstElementChild;

      let formData = new FormData(formElement);

      formData.set("fields[resourceUrl]", this.destinationUrl);
      formData.set("fields[resourceName]", this.resourceName);
      formData.set("fields[resourceImage]", this.resourceImage);

      if (this.emailInputModel) {
        formData.set("fields[email]", this.emailInputModel);
        formData.set("fields[firstTimeUser]", '0');
      } else {
        this.emailInputModel = formData.get("fields[email]").toString();
        formData.set("fields[firstTimeUser]", '1');
      }

      axios
        .post("/sprout-forms/entries/save-entry", formData)
        .then((response) => {
          if (response.data.success) {
            this.$emit("successful-submission");
            localStorage.setItem("authGateEmail", this.emailInputModel);
            this.status = "success";
            this.continueNavigation();
          } else {
            if (response.data.errors) {
              this.status = "pending";
              this.errors = response.data.errors;
            }
          }
        })
        .catch((error) => {
          this.failure = true;
        });
    },
    continueNavigation() {
      window.open(this.destinationUrl, "_blank");
      window.focus();
    },
  },
};
</script>
